import Vue from 'vue'
import { dataPrivacy } from '@/m-common/lib/util/dataPrivacy.js'

// 主逻辑：添加眼睛图片，处理文字加密
function dealPrivacy(el, binding) {
  // <div><span v-dataPrivacy>500236199611020632</span>----加</div>
  // <div><span v-dataPrivacy="true">500236199611020632</span>----加</div>
  // <div><span v-dataPrivacy="false">500236199611020632</span>----不加</div>
  // <div><span v-dataPrivacy="{type: 'center'}">500236199611020632</span>----中间加</div>
  // <div><span v-dataPrivacy="{type: 'end'}">500236199611020632</span>----尾部加</div>
  // <div><span v-dataPrivacy="{type: ''}">500236199611020632</span>----type传空，等同于不加密</div>
  // <div><span v-dataPrivacy="{type: 'end'}">{{ test || '暂无数据' }}</span>----当值为空时不加，原样返回，有值时加</div>
  // </div>

  // 例子：v-dataPrivacy="!!item.dataPrivacy"
  if (binding.value === false) {
    return
  }
  // if (Object.prototype.toString.call(binding.value) === '[object Object]' &&
  //    'isOpen' in binding.value && !binding.value.isOpen) {
  //    先注释：动态配置是否脱敏或者不脱敏的暂时还有点问题，比如一开始用户脱敏后又改成不脱敏，那么如果恢复最初的值是个问题。如果值是个变量一直在变，很难拿到准确的值
  //   el.firstChild.data = el.initTextValue
  //   // 用户可以用配置里的isOpen或者直接等于true|false来控制是否要脱敏，默认不传代表true。如果传了false代表不要脱敏
  //   return
  // }
  // 当获取的是这些值得时候，原样返回，无需脱敏
  const exclude = ['-', '--', '无', '暂无', '暂无数据']
  if (exclude.includes(el.innerText)) {
    return
  }
  // 例子：获取type值，如 v-dataPrivacy="{type: 'center'}" 、v-dataPrivacy="{type: 'end'}  v-dataPrivacy这种写法时代表默认使用center"
  let type = 'center'

  if (Object.prototype.toString.call(binding.value) === '[object Object]' && 'type' in binding.value) {
    type = binding.value.type
  }

  const domImgParent = el
  const text = dataPrivacy(el.innerText, {
    type
  })
  domImgParent.firstChild.data = text
}
Vue.directive('dataPrivacy', {
  bind(el, binding, vnode) {
    dealPrivacy(el, binding)
  },
  componentUpdated(el, binding, vnode) {
    dealPrivacy(el, binding)
  },
})



// WEBPACK FOOTER //
// ./src/m-common/directive/dataPrivacy/index.js